import React, { Component } from 'react';

import './contactform.css';
import Button from '../button/button';
import get from 'lodash.get';
import { gravityFormsRequest } from '../../utilities';

class Contactform extends Component {

    constructor(props) {
        super(props);

        this.state = {
            form: {
                naam: {
                    value: '',
                    error: ''
                },
                organisatie: {
                    value: '',
                    error: ''
                },
                emailadres: {
                    value: '',
                    error: ''
                },
                telefoonnummer: {
                    value: '',
                    error: ''
                },
                bericht: {
                    value: '',
                    error: ''
                },
                nieuwsbrief: {
                    value: '',
                    error: ''
                }
            },
            processed: false,
            busy: false,
            confirmation: ""
        };

        this.spam = this.spam.bind(this);

        this.updateFormState = this.updateFormState.bind(this);
    }

    spam(event) {
        event.preventDefault();
        this.updateFormState();

        this.setState(...this.state, {busy: true});

        const gravityFormsSettings = {
            publicKey: process.env.REACT_APP_GRAVITYFORMS_PUBLICKEY,
            privateKey: process.env.REACT_APP_GRAVITYFORMS_PRIVATEKEY,
            domain: process.env.REACT_APP_APIHOST
        };

        const method = 'POST';
        const route = `forms/${process.env.REACT_APP_GRAVITYFORMS_CONTACTFORMID}/submissions`;

        let data = {
            input_values: {
                input_1: this.refs.naam.value,
                input_2: this.refs.emailadres.value,
                input_3: this.refs.organisatie.value,
                input_4: this.refs.telefoonnummer.value,
                input_5: this.refs.bericht.value,
                input_6_1: this.refs.nieuwsbrief.checked ? 'Ja' : ''
            }
        };

        let hacky = this;

        gravityFormsRequest(gravityFormsSettings, method, route, data).then((response) => {
            return response.json();
        }).then((data) => {
            if (data.response.is_valid) {
                hacky.setState(...hacky.state, {processed: true, busy: false, confirmation: data.response.confirmation_message});
            } else {

                let errors = {};

                Object.entries(data.response.validation_messages).forEach(([key, value]) => {

                        switch (key) {
                            case "1":
                                errors = Object.assign(errors, {naam: { error: value}});
                                break;

                            case "2":
                                errors = Object.assign(errors, {emailadres: { error: value}});
                                break;

                            case "5":
                                errors = Object.assign(errors, {bericht: { error: value}});
                                break;

                            default:

                                break;
                        }
                    }
                );

                hacky.setState(...hacky.state, {form: errors, busy: false});
            }
        });
    }

    updateFormState() {
        this.setState({
            form: {
                naam: {
                    value: this.refs.naam.value,
                    error: ''
                },
                organisatie: {
                    value: this.refs.organisatie.value,
                    error: ''
                },
                emailadres: {
                    value: this.refs.emailadres.value,
                    error: ''
                },
                telefoonnummer: {
                    value: this.refs.telefoonnummer.value,
                    error: ''
                },
                bericht: {
                    value: this.refs.bericht.value,
                    error: ''
                },
                nieuwsbrief: {
                    value: '',
                    error: ''
                }
            },
        });
    };

    render() {

        if (this.state.processed === true) {
            return (
                <div className="form" dangerouslySetInnerHTML={{__html: this.state.confirmation}}></div>
            );
        }

        const buttonText = this.state.busy ? 'Bezig' : 'Verstuur';

        return (
            <div className="form">
                <form className="contactform" onSubmit={this.spam}>
                    <div className="contactform__element contactform__element--naam"><label htmlFor="contactform__naam">Naam</label><span><input type="text" name="contactform__naam" ref="naam"/></span>{this.error("naam")}</div>
                    <div className="contactform__element contactform__element--organisatie"><label htmlFor="contactform__organisatie">Bedrijf / organisatie</label><span><input type="text" name="contactform__organisatie" ref="organisatie"/></span>{this.error("organisatie")}</div>
                    <div className="contactform__element contactform__element--emailadres"><label htmlFor="contactform__emailadres">E-mailadres</label><span><input type="text" name="contactform__emailadres" ref="emailadres" /></span>{this.error("emailadres")}</div>
                    <div className="contactform__element contactform__element--telefoonnummer"><label htmlFor="contactform__telefoonnummer">Telefoonnummer</label><span><input type="text" name="contactform__telefoonnummer" ref="telefoonnummer"/></span>{this.error("telefoonnummer")}</div>
                    <div className="contactform__element contactform__element--bericht"><label htmlFor="contactform__bericht">Bericht</label><span><textarea type="text" name="contactform__bericht" ref="bericht"/></span>{this.error("bericht")}</div>
                    <div className="contactform__element contactform__element--nieuwsbrief"><input type="checkbox" id="contactform__nieuwsbrief" ref="nieuwsbrief" name="contactform__nieuwsbrief" value=""/><label htmlFor="contactform__nieuwsbrief"><span className="fakecheckbox"/>Ik wil graag de KWOOT nieuwsbrief ontvangen.</label></div>
                    <div className="contactform__element contactform__element--verstuur" onClick={this.spam}><Button name={buttonText} color="transparent" bordercolor="grey" disabled={this.state.busy}/> </div>
                </form>
            </div>
        );

    }

    error(field) {

        return (
            <div className="error">
                { get(this, `state.form.${field}.error`, '') }
            </div>
        );

    }
}

export default Contactform;



// WEBPACK FOOTER //
// ./src/components/contactform/contactform.js